module.exports = __webpack_public_path__ + "img/3.afc2e8fb.jpg";